/* MENGENSTAFFEL - PRODUKTSEITEN
 * ---------------------------------------------------------------------------
 * Zwei Modi, je nach Buybox auf der Seite:
 *
 *   A) MICAVO-Seiten (lb-theone-buybox, Klasse .lbgs__box)
 *      Ersetzt die statische Staffel-Zeile durch klickbare Mengenkarten
 *      (1x / 2x / 3x) und blendet den doppelten Mengen-Stepper aus.
 *
 *   B) Uebrige Produktseiten (Standard-Prestige-Buybox)
 *      Fuegt vor den Kaufbuttons einen Hinweis auf die Staffel ein,
 *      inklusive konkretem 2er-Preis.
 *
 * Rabatte (automatisch in Shopify, seit 21.08.2026 fuer ALLE Produkte):
 *   ab 2 Artikel 15 %, ab 3 Artikel 20 %
 * Aendern sich die Stufen, muss TIERS unten angepasst werden.
 *
 * WICHTIG - Stepper: Der qty-Block der MICAVO-Buybox darf im Theme-Editor
 * NICHT geloescht werden. Der Selektor schreibt seinen Wert in dessen
 * input[name="quantity"]; er wird nur optisch versteckt.
 *
 * WICHTIG - Rundung: Shopify berechnet den Rabatt auf die ZEILENSUMME und
 * rundet den Rabattbetrag auf volle Cent ab:
 *   2 x 13,99 = 27,98 -> 27,98 * 15%% = 4,197 -> Rabatt 4,19 -> 23,79
 * Eine Rechnung pro Stueck ergaebe 23,80 und waere einen Cent zu hoch.
 * Hinweis: Der fruehere collection-basierte Rabatt rundete pro Stueck.
 * Nach der Umstellung auf "alle Produkte" am 21.08.2026 gilt die Zeilensumme.
 * Gegen /cart.js verifiziert fuer 13,99 / 17,99 / 23,99 bei Menge 2 und 3.
 */
(function () {
  'use strict';

  var TIERS = { 1: 0, 2: 0.15, 3: 0.20 };
  var KOMBI_TEXT = 'alle Produkte frei kombinierbar';
  var CSS_ID = 'mvq-style';

  var CSS = '.mvq{margin:0 0 9px}'
    + '.mvq__head{font-size:13px;line-height:18px;font-weight:700;color:#111;margin:0 0 8px}'
    + '.mvq__grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}'
    + '.mvq__opt{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:2px;padding:14px 6px 10px;min-height:96px;cursor:pointer;background:#fff;color:#111;border:1px solid #e0e0e0;border-radius:10px;font-family:inherit;text-align:center;transition:background .15s,border-color .15s,color .15s;-webkit-appearance:none;appearance:none}'
    + '.mvq__opt:hover{border-color:#111}'
    + '.mvq__opt.is-on{background:#111;border-color:#111;color:#fff}'
    + '.mvq__label{font-size:13px;line-height:16px;opacity:.85}'
    + '.mvq__total{font-size:17px;line-height:22px;font-weight:700;white-space:nowrap}'
    + '.mvq__unit{font-size:11px;line-height:14px;opacity:.8}'
    + '.mvq__unit s{opacity:.6;margin-left:3px}'
    + '.mvq__sub{font-size:11px;line-height:14px;opacity:.6}'
    + '.mvq__save{display:inline-block;margin-top:4px;padding:2px 7px;border-radius:999px;background:#c8f135;color:#111;font-size:11px;line-height:15px;font-weight:700;white-space:nowrap}'
    + '.mvq__flag{position:absolute;top:-8px;left:50%;transform:translateX(-50%);padding:2px 8px;border-radius:999px;background:#c8f135;color:#111;font-size:10px;line-height:14px;font-weight:700;white-space:nowrap}'
    + '.mvq__opt[data-mvq-qty="2"]{padding-top:18px}'
    + '.mvq__note{font-size:11px;line-height:15px;color:#666;margin:8px 0 0}'
    + '[data-mvq-hidden]{display:none !important}'
    + '.mvq-tip{display:block;padding:10px 12px;margin:0 0 14px;border-radius:8px;background:#f2f2f2;color:#111;font-size:13px;line-height:18px}'
    + '.mvq-tip__head{font-weight:700}'
    + '.mvq-tip__sub{display:block;margin-top:2px;font-size:12px;line-height:16px;color:#555}'
    + '.mvq-tip__sub s{opacity:.65}'
    + '@media (max-width:400px){.mvq__total{font-size:15px}.mvq__opt{padding:12px 4px 8px;min-height:92px}.mvq__flag{font-size:9px;padding:2px 6px}.mvq__unit{font-size:10px}}';

  function injectCss() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function parsePrice(txt) {
    if (!txt) return null;
    var m = txt.replace(/\s/g, '').match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)([.,]\d{2})?/);
    if (!m) return null;
    var whole = m[1].replace(/[.\s]/g, '');
    var frac = m[2] ? m[2].substring(1) : '00';
    var val = parseFloat(whole + '.' + frac);
    return isNaN(val) ? null : val;
  }

  /* Rabatt auf die Zeilensumme, Betrag auf volle Cent abgerundet. */
  function tier(base, qty) {
    var rate = TIERS[qty] || 0;
    var full = Math.round(base * qty * 100) / 100;
    if (!rate) return { full: full, net: full, save: 0, unit: base };
    var save = Math.floor(Math.round(full * rate * 10000) / 100) / 100;
    var net = Math.round((full - save) * 100) / 100;
    return { full: full, net: net, save: save, unit: Math.round((net / qty) * 100) / 100 };
  }

  function makeEuro(raw) {
    var symbolFirst = /€\s*\d/.test(raw);
    var sep = /\d,\d{2}/.test(raw) ? ',' : '.';
    return function (n) {
      var s = n.toFixed(2).replace('.', sep);
      return symbolFirst ? '€' + s : s + ' €';
    };
  }

  /* ---------------------------------------------------------------- Modus A */

  function findNotice() {
    var re = /ab\s*2\b[^%]{0,24}[−–—-]\s*15\s*%/i;
    var best = null;
    var nodes = document.querySelectorAll('.lbgs__box div, .lbgs__box p, .lbgs__box span');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.querySelector('[data-mvq]')) continue;
      var t = n.textContent || '';
      if (t.length > 300) continue;
      if (!re.test(t)) continue;
      if (!best || t.length < (best.textContent || '').length) best = n;
    }
    return best;
  }

  function qtyInputs() {
    var l = document.querySelectorAll('.lbgs__qty-input');
    return l.length ? l : document.querySelectorAll('input[name="quantity"]');
  }

  function hideStepper() {
    var pickers = document.querySelectorAll('.lbgs__qty-picker');
    for (var i = 0; i < pickers.length; i++) {
      if (!pickers[i].querySelector('input[name="quantity"]')) continue;
      pickers[i].setAttribute('data-mvq-hidden', '1');
    }
  }

  function buildTiers() {
    if (document.querySelector('[data-mvq]')) return true;

    var notice = findNotice();
    if (!notice) return false;

    var priceEl = document.querySelector('.lbgs__price');
    if (!priceEl) return false;

    var raw = priceEl.textContent || '';
    var base = parsePrice(raw);
    if (!base || base <= 0) return false;
    if (!qtyInputs().length) return false;

    var euro = makeEuro(raw);
    injectCss();

    var html = '<div class="mvq" data-mvq>'
      + '<div class="mvq__head">Menge wählen &amp; sparen</div>'
      + '<div class="mvq__grid">'
      + '<button type="button" class="mvq__opt is-on" data-mvq-qty="1"><span class="mvq__label">1 ×</span><span class="mvq__total" data-mvq-total="1">&nbsp;</span><span class="mvq__sub">Einzelpreis</span></button>'
      + '<button type="button" class="mvq__opt" data-mvq-qty="2"><span class="mvq__flag">Beliebteste Wahl</span><span class="mvq__label">2 ×</span><span class="mvq__total" data-mvq-total="2">&nbsp;</span><span class="mvq__unit" data-mvq-unit="2"></span><span class="mvq__save" data-mvq-save="2"></span></button>'
      + '<button type="button" class="mvq__opt" data-mvq-qty="3"><span class="mvq__label">3 ×</span><span class="mvq__total" data-mvq-total="3">&nbsp;</span><span class="mvq__unit" data-mvq-unit="3"></span><span class="mvq__save" data-mvq-save="3"></span></button>'
      + '</div>'
      + '<div class="mvq__note">Rabatt wird im Warenkorb automatisch abgezogen · ' + KOMBI_TEXT + '</div>'
      + '</div>';

    notice.insertAdjacentHTML('afterend', html);
    notice.style.display = 'none';
    notice.setAttribute('data-mvq-replaced', '1');

    var root = notice.parentNode.querySelector('[data-mvq]');
    if (!root) return false;

    [1, 2, 3].forEach(function (q) {
      var t = tier(base, q);
      var elTotal = root.querySelector('[data-mvq-total="' + q + '"]');
      var elUnit = root.querySelector('[data-mvq-unit="' + q + '"]');
      var elSave = root.querySelector('[data-mvq-save="' + q + '"]');

      if (elTotal) elTotal.textContent = euro(t.net);
      if (elUnit && t.save > 0) elUnit.innerHTML = 'je ' + euro(t.unit) + ' <s>' + euro(base) + '</s>';
      if (elSave && t.save > 0) elSave.textContent = 'spare ' + euro(t.save);
    });

    function paint(qty) {
      root.querySelectorAll('[data-mvq-qty]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-mvq-qty') === String(qty));
      });
    }

    root.querySelectorAll('[data-mvq-qty]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var q = parseInt(btn.getAttribute('data-mvq-qty'), 10);
        qtyInputs().forEach(function (inp) {
          if (inp.value === String(q)) return;
          inp.value = String(q);
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        paint(q);
      });
    });

    qtyInputs().forEach(function (inp) {
      inp.addEventListener('change', function () {
        paint(parseInt(inp.value, 10) || 1);
      });
    });

    var first = qtyInputs()[0];
    paint(first ? (parseInt(first.value, 10) || 1) : 1);

    hideStepper();
    return true;
  }

  /* ---------------------------------------------------------------- Modus B */

  function buildTip() {
    if (document.querySelector('[data-mvq-tip]')) return true;

    var anchor = document.querySelector('buy-buttons');
    if (!anchor) return false;

    var priceEl = document.querySelector('.price-list--product') || document.querySelector('.price-list');
    if (!priceEl) return false;

    var raw = priceEl.textContent || '';
    var base = parsePrice(raw);
    if (!base || base <= 0) return false;

    var euro = makeEuro(raw);
    var t2 = tier(base, 2);

    injectCss();

    var html = '<div class="mvq-tip" data-mvq-tip>'
      + '<span class="mvq-tip__head">Ab 2 Artikel 15 % sparen, ab 3 Artikel 20 %</span>'
      + '<span class="mvq-tip__sub">2 × für ' + euro(t2.net) + ' <s>' + euro(t2.full) + '</s> · ' + KOMBI_TEXT + '</span>'
      + '</div>';

    anchor.insertAdjacentHTML('beforebegin', html);
    return true;
  }

  /* ------------------------------------------------------------------- Boot */

  function attempt() {
    if (document.querySelector('.lbgs__box')) return buildTiers();
    return buildTip();
  }

  function boot() {
    var tries = 0;
    (function loop() {
      if (attempt()) return;
      if (tries++ < 25) setTimeout(loop, 120);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 80); });
})();
